module.exports = __webpack_public_path__ + "static/img/logo.d11a3873.png";